<div class="checkbox-group" [ngClass]="{'inline-group': isInline}" [formGroup]="groupControl">
  <checkbox *ngFor="let item of items; let i = index" class="mr-15px mb-15px" [undefinedState]="undefinedState" [buttonView]="buttonView"
    [label]="item.label" [blueCheck]="blueCheck" formControlName="{{item.value}}">
    {{item.label}}
  </checkbox>
</div>
